// Подписка этого устройства на push-уведомления (PushManager). Сервер хранит подписку,
// а переключатель в «Настройках» показывает, есть ли она у устройства.

/** Есть ли в браузере всё нужное. На iPhone — только в приложении с экрана «Домой» (iOS 16.4+). */
export function pushSupported(): boolean {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function notificationPermission(): NotificationPermission {
  return 'Notification' in window ? Notification.permission : 'default';
}

async function registration(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) return null;
  return (await navigator.serviceWorker.getRegistration()) ?? null;
}

/** Текущая подписка устройства или null. */
export async function deviceSubscription(): Promise<PushSubscription | null> {
  if (!pushSupported()) return null;
  const reg = await registration();
  return reg ? reg.pushManager.getSubscription() : null;
}

function keyBytes(b64url: string): Uint8Array<ArrayBuffer> {
  const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - (b64url.length % 4)) % 4);
  const raw = atob(b64);
  const out = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

/**
 * Подписать устройство ключом сервера. Разрешение запрашивается до вызова (в обработчике нажатия).
 * Подписка со старым ключом (сервер сменил ключ) заменяется новой.
 */
export async function subscribeDevice(publicKey: string): Promise<PushSubscription> {
  const reg = (await navigator.serviceWorker.ready) as ServiceWorkerRegistration;
  const opts = { userVisibleOnly: true, applicationServerKey: keyBytes(publicKey) };
  try {
    return await reg.pushManager.subscribe(opts);
  } catch (e) {
    const old = await reg.pushManager.getSubscription();
    if (!old) throw e;
    await old.unsubscribe();
    return reg.pushManager.subscribe(opts);
  }
}
